import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CareerForm from "./Pages/CareerForm";
import Contact from "./Pages/Contact";
import BlogDetails from "./Pages/BlogDetails";
import { HelmetProvider } from "react-helmet-async";
import DynamicBlogPage from "./Pages/DynamicBlogPage";
import DynamicCareer from "./Pages/DynamicCareer";
import JobDetailPage from "./Pages/JobDetailPage";
import JobApplicationForm from "./Pages/JobApplicationForm";
import ApplyPage from "./Pages/ApplyPage";
import ApplicationForm from "./Pages/ApplicationForm";
import Login from "./Components/Auth/Login";
import Signup from "./Components/Auth/Signup";
import ProtectedRoute from "./Components/Auth/ProtectedRoute";
import Profile from "./Pages/Profile";
import LoadingSpinner from "./Components/common/LoadingSpinner";

const WebsiteDesignDevelopment = lazy(() => import("./Pages/WebsiteDesignDevelopment"));
const MedicalBilling = lazy(() => import("./Pages/MedicalBilling"));
const AndroidApplications = lazy(() => import("./Pages/AndroidApplications"));
const HostingDomainRegistration = lazy(() => import("./Pages/HostingDomainRegistration"));
const ContentWriting = lazy(() => import("./Pages/ContentWriting"));
const DigitalMarketingSEO = lazy(() => import("./Pages/DigitalMarketingSEO"));
const TrainingDevelopment = lazy(() => import("./Pages/TrainingDevelopment"));

const Footer = lazy(() => import("./Components/Footer/Footer"));
const Navbar = lazy(() => import("./Components/Nav/Navbar"));
const About = lazy(() => import("./Pages/About"));
const Career = lazy(() => import("./Pages/Career"));
const Home = lazy(() => import("./Pages/Home"));
const Service = lazy(() => import("./Pages/Service"));
const Testimonial = lazy(() => import("./Pages/Testimonial"));
const WebdevService = lazy(() => import("./Pages/WebdevService"));
const Blog = lazy(() => import("./Pages/Blog"));
const DataAnalysis = lazy(() => import("./Pages/DataAnalysis"));
const PrivacyPolicy = lazy(() => import("./Pages/PrivacyPolicy"));
const OurWorks = lazy(() => import("./Pages/OurWorks"));


function App() {

  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <Suspense fallback={<LoadingSpinner />}>  
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/application" element={
                <ProtectedRoute>
                  <ApplicationForm />
                </ProtectedRoute>
              } />
              

              <Route path="/testimonial" element={<Testimonial />} />
              <Route path="/our-works" element={<OurWorks />} />
              <Route path="/service" element={<Service />} />
              <Route path="/service/webdev" element={<WebdevService />} />
              <Route path="/career" element={<DynamicCareer />} />


              <Route path="/contact" element={<Contact />} />
              {/* <Route path="/career/apply5" element={<CareerForm />} /> */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path='/blog' element={<DynamicBlogPage />} />
              {/* New service-specific routes */}
              <Route path="/blog/:slug" element={<BlogDetails />} />
              <Route path="/jobs" element={<DynamicCareer />} />
              <Route path="/jobs/application" element={<JobApplicationForm />} />
              <Route path="/career/apply" element={<ApplyPage />} />


              <Route path="/job/:slug" element={<JobDetailPage />} />

              <Route
                path="/service/website-design-development"
                element={<WebsiteDesignDevelopment />}
              />
              <Route
                path="/service/medical-billing"
                element={<MedicalBilling />}
              />
              <Route
                path="/service/android-applications"
                element={<AndroidApplications />}
              />
              <Route
                path="/service/hosting-domain-registration"
                element={<HostingDomainRegistration />}
              />
              <Route
                path="/service/content-writing"
                element={<ContentWriting />}
              />
              <Route
                path="/service/digital-marketing-seo"
                element={<DigitalMarketingSEO />}
              />
              <Route
                path="/service/training-development"
                element={<TrainingDevelopment />}
              />

              <Route path="/service/data-analysis" element={<DataAnalysis />} />
            </Routes>
            <Footer />
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
